import { withDisplayCurrency } from "@/features/display-currency/display-currency.utils";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { QueryHookOptions, useQuery } from "@apollo/client";
import relatedProductsGql from "@whoppah/apollo/query/relatedProducts.graphql";
import {
  RelatedProductsQuery,
  RelatedProductsQueryVariables,
} from "@whoppah/apollo/schema";

const useRelatedProducts = (
  options?: QueryHookOptions<
    RelatedProductsQuery,
    RelatedProductsQueryVariables
  >
) => {
  const currency = useDisplayCurrency();

  return useQuery(relatedProductsGql, withDisplayCurrency(options, currency));
};

export default useRelatedProducts;
